<script>
    import PromptObject from './PromptObject.vue';

    export default {
        computed: {
            prompts() {return this.$store.getters.PROMPTS},
        },
        components: {
            PromptObject: PromptObject,
        }
    }
</script>


<template>
    <div class="right_header">
        <label>Prompts</label>
    </div>
    <ul class="clear_ul">
        <PromptObject
            v-for="(promptValue, promptIndex) in prompts" :key="promptIndex" 
            :prompt = "promptValue"
        />
    </ul>
</template>